import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import useRouteMeta from '../../../hooks/useRouteMeta';
import './FAQsPage.css';
import { faqData } from './faqsData';

const FAQsPage = () => {
  // SEO Meta Tags - Automatically applied from config
  useRouteMeta();
  
  const [activeAccordion, setActiveAccordion] = useState('1-0');

  const handleAccordionClick = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  return (
    <div className="faqs-page">
      <Header />

      <div className="comman-gradient-header bg-linear-gradient-30">
        <div className="container">
          <h1>Frequently Asked Questions (FAQs)</h1>
          <p>
            Welcome to the Glammify FAQ section! Whether you're new or looking to maximize your experience,
            we've got answers to your most common questions.
          </p>
        </div>
      </div>

      <div className="faqs-content">
        <div className="faqs-container">
          {faqData.map((category, categoryIndex) => (
            <div key={category.id} className="faq-category">
              <h2 className="title" dangerouslySetInnerHTML={{ __html: category.title }}></h2>
              <div className="accordion" id={`accordion${category.id}`}>
                {category.questions.map((faq, questionIndex) => {
                  const uniqueId = `${category.id}-${questionIndex}`;
                  const isActive = activeAccordion === uniqueId;
                  
                  return (
                    <div key={faq.id} className="accordion-item">
                      <h2 className="accordion-header">
                        <button 
                          className={`accordion-button ${!isActive ? 'collapsed' : ''}`}
                          type="button"
                          aria-expanded={isActive}
                          aria-controls={`collapse${uniqueId}`}
                          onClick={() => handleAccordionClick(uniqueId)}
                        >
                          {faq.question}
                        </button>
                      </h2>
                      <div 
                        id={`collapse${uniqueId}`} 
                        className={`accordion-collapse collapse ${isActive ? 'show' : ''}`}
                      >
                        <div className="accordion-body" dangerouslySetInnerHTML={{ __html: faq.answer }} />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FAQsPage;
